import React from "react";

import CompaniesHired from "../CompaniesHired/CompaniesHired";

import "./CompaniesMarquee.css";

/** Same marquee strips as intensive-english, inside v2 section wrapper */
export default function CompaniesMarquee() {
  return (
    <section className="section-2811">
      <div className="w-layout-blockcontainer intensive-container center w-container">
        <h2 className="h2-heading companies-marquee-v2__heading">
          3000+ Companies Have Hired
          <br />
          From Us Till Date
        </h2>
        <CompaniesHired hideHeading />
      </div>
    </section>
  );
}
